import { network } from 'services/network';

export const getActivityCodesAliases = (contractId) => {
    return network.get(`api/bo/getActivityCodesAliases?contractId=${contractId}`).then((response) => {
        return response.data;
    });
};
